/**
 * App Entry File
 * Vuely: A Powerfull Material Design Admin Template
 * Copyright 2018. All Rights Reserved
 * Created By: The Iron Network, LLC
 * Made with Love
 */
//import 'core-js'
//import 'core-js/shim'
//import '@babel/polyfill'

import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueBreadcrumbs from 'vue2-breadcrumbs'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import Nprogress from 'nprogress'
import VueI18n from 'vue-i18n'
import fullscreen from 'vue-fullscreen'
import ButtonStatus from 'vue-js-toggle-button'
import multiselect from 'multiselect'
import VueHtml2Canvas from 'vue-html2canvas'
import JsonExcel from 'vue-json-excel'

// global components
import GlobalComponents from './globalComponents'

// app.vue
import App from './App'

// router
import router from './router'

// store
import { store } from './store/store'

import {
    emails_group_it,
    emails_group_special,
} from './assets/jsondata/auth_list.json'

// include all css files
import './lib/VuelyCss'
import './lib/VuelyScript'

// messages
import messages from './lang'
import quicksearch from 'jquery.quicksearch'

import VueNumerals from 'vue-numerals'
Vue.use(VueNumerals, {
    locale: 'th',
})

import vueNumeralFilterInstaller from 'vue-numeral-filter'
Vue.use(vueNumeralFilterInstaller)

// navigation guards before each
router.beforeEach(async (to, from, next) => {
    Nprogress.start()

    const public_path = to.path.match(/public/gi)
    const userInfo = (await store.getters.getUser) || null

    // return false
    if (!public_path) {
        // check  authenticated for access page
        const publicPages = [
            '/admin/login',
            '/admin/pastlogin',
            '/session/sign-up',
        ]
        const authRequired = !publicPages.includes(to.path)
        const loggedIn = (await store.getters.isLoggedin) || false

        // check for redirect default route when user type ad_auth
        if (authRequired && !loggedIn) {
            return next('/admin/login')
        } else if (userInfo != null) {
            if (
                userInfo.type == 'ad_auth' &&
                to.path.match(/admin\/setting/gi)
            ) {
                return next('/')
            }
            return next()
        }
    }
    return next()
})

// navigation guard after each
router.afterEach((to, from) => {
    Nprogress.done()

    setTimeout(() => {
        const contentWrapper = document.querySelector('.v-content__wrap')
        if (contentWrapper !== null) {
            contentWrapper.scrollTop = 0
        }
        const boxedLayout = document.querySelector(
            '.app-boxed-layout .app-content'
        )
        if (boxedLayout !== null) {
            boxedLayout.scrollTop = 0
        }
        const miniLayout = document.querySelector(
            '.app-mini-layout .app-content'
        )
        if (miniLayout !== null) {
            miniLayout.scrollTop = 0
        }
    }, 200)
})

// plugins
Vue.use(Vuetify, {
    theme: store.getters.selectedTheme.theme,
})
Vue.use(multiselect)
Vue.use(ButtonStatus)
Vue.use(VueI18n)
Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(fullscreen)
Vue.use(GlobalComponents)

//export
Vue.use(VueHtml2Canvas)
Vue.component('downloadExcel', JsonExcel)

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: store.getters.selectedLocale.locale, // set locale
    messages, // set locale messages
})

/* eslint-disable */
/* eslint-disable no-new */
new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
    components: { App },
}).$mount('#app')
